
import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../../../components/base/Card';
import { Button } from '../../../components/base/Button';
import { latestNews } from '../../../mocks/news';

export const NewsSection: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Latest News</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Stay updated with the latest happenings at Kanoon Persian Cultural Center
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {latestNews.map((article) => (
            <Card key={article.id} hover className="overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-40 object-cover object-top"
              />
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2 py-1 rounded-full">
                    {article.category}
                  </span>
                  <span className="text-gray-500 text-xs">
                    {article.date}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-gray-700 text-sm mb-4 line-clamp-3">
                  {article.excerpt}
                </p>
                <Button size="sm" variant="outline" className="w-full">
                  Read More
                </Button>
              </div>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Link to="/news">
            <Button variant="outline" size="lg">
              View All News
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
